/* src/components/Solar/SystemCompare.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	add_flush_callback,
	append_hydration,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	group_outros,
	init,
	insert_hydration,
	listen,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	space,
	src_url_equal,
	text,
	to_number,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

import {
	roundToMax2Decimals,
	roundFormat
} from '../../helpers/svelte/utils/formatters';

import EmbedModal from '../EmbedModal/EmbedModal.svelte';
import Tooltip from '../Tooltip/Tooltip.svelte';
import { onMount } from 'svelte';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[31] = list[i];
	child_ctx[33] = i;
	return child_ctx;
}

// (151:0) {#if embedDetector}
function create_if_block_2(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { id: true, class: true });
			children(div).forEach(detach);
			this.h();
		},
		h() {
			attr(div, "id", /*embedDetector*/ ctx[4]);
			attr(div, "class", "svelte-dsa0xa");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*embedDetector*/ 16) {
				attr(div, "id", /*embedDetector*/ ctx[4]);
			}
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (307:12) {:else}
function create_else_block(ctx) {
	let div;
	let t;

	return {
		c() {
			div = element("div");
			t = text("Please type a valid utility bill.");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			t = claim_text(div_nodes, "Please type a valid utility bill.");
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "benefits__error-message svelte-dsa0xa");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, t);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (246:12) {#if userUtilityBill > 0}
function create_if_block_1(ctx) {
	let div0;
	let span2;
	let img0;
	let img0_src_value;
	let t0;
	let span0;
	let t1;
	let t2_value = /*size*/ ctx[31] + "";
	let t2;
	let t3;
	let span1;
	let t4;
	let t5;
	let t6;
	let ul0;
	let li0;
	let span3;
	let t7;
	let tooltip0;
	let t8;
	let span4;
	let t9_value = roundFormat(/*getkWhProducedYearly*/ ctx[14](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9])) + "";
	let t9;
	let t10;
	let t11;
	let li1;
	let span5;
	let t12;
	let t13;
	let span6;
	let t14;
	let t15_value = roundFormat(/*getMonthlySavings*/ ctx[15](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9])) + "";
	let t15;
	let t16;
	let li2;
	let span7;
	let t17;
	let t18;
	let span8;
	let t19_value = /*getPaybackPeriod*/ ctx[12](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9]) + "";
	let t19;
	let t20;
	let tooltip1;
	let t21;
	let div1;
	let span9;
	let img1;
	let img1_src_value;
	let t22;
	let t23;
	let ul1;
	let li3;
	let span10;
	let t24;
	let t25;
	let span11;
	let t26_value = /*getCO2EmissionsInTons*/ ctx[17](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9]) + "";
	let t26;
	let t27;
	let t28;
	let li4;
	let span12;
	let t29;
	let t30;
	let span13;
	let t31_value = /*getTreesPlantedPerYear*/ ctx[19](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9]) + "";
	let t31;
	let t32;
	let t33;
	let li5;
	let span14;
	let t34;
	let t35;
	let span15;
	let t36_value = /*getMilesPerYear*/ ctx[18](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9]) + "";
	let t36;
	let t37;
	let current;

	tooltip0 = new Tooltip({
			props: {
				text: "Equivalent to about $" + roundFormat(/*getConsumptionPercentage*/ ctx[13](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9], true)) + "% of yearly electricity needs based on a monthly bill of $" + roundFormat(/*userUtilityBill*/ ctx[9]) + "."
			}
		});

	tooltip1 = new Tooltip({
			props: {
				text: "Payback period might be less depending on applicable rebates."
			}
		});

	return {
		c() {
			div0 = element("div");
			span2 = element("span");
			img0 = element("img");
			t0 = text("\n                  Savings from ");
			span0 = element("span");
			t1 = text("a ");
			t2 = text(t2_value);
			t3 = text("kW");
			span1 = element("span");
			t4 = text("this");
			t5 = text(" system");
			t6 = space();
			ul0 = element("ul");
			li0 = element("li");
			span3 = element("span");
			t7 = text("Est. yearly production\n                      ");
			create_component(tooltip0.$$.fragment);
			t8 = space();
			span4 = element("span");
			t9 = text(t9_value);
			t10 = text(" kWh");
			t11 = space();
			li1 = element("li");
			span5 = element("span");
			t12 = text("Est. monthly savings");
			t13 = space();
			span6 = element("span");
			t14 = text("$");
			t15 = text(t15_value);
			t16 = space();
			li2 = element("li");
			span7 = element("span");
			t17 = text("Full payback in");
			t18 = space();
			span8 = element("span");
			t19 = text(t19_value);
			t20 = text(" years\n                      ");
			create_component(tooltip1.$$.fragment);
			t21 = space();
			div1 = element("div");
			span9 = element("span");
			img1 = element("img");
			t22 = text("\n                  Environmental Impacts");
			t23 = space();
			ul1 = element("ul");
			li3 = element("li");
			span10 = element("span");
			t24 = text("Reduces CO2 emissions by");
			t25 = space();
			span11 = element("span");
			t26 = text(t26_value);
			t27 = text(" tons a year");
			t28 = space();
			li4 = element("li");
			span12 = element("span");
			t29 = text("Equivalent to planting");
			t30 = space();
			span13 = element("span");
			t31 = text(t31_value);
			t32 = text(" trees a year");
			t33 = space();
			li5 = element("li");
			span14 = element("span");
			t34 = text("Equivalent to driving");
			t35 = space();
			span15 = element("span");
			t36 = text(t36_value);
			t37 = text(" mi less a year");
			this.h();
		},
		l(nodes) {
			div0 = claim_element(nodes, "DIV", {});
			var div0_nodes = children(div0);
			span2 = claim_element(div0_nodes, "SPAN", { class: true });
			var span2_nodes = children(span2);

			img0 = claim_element(span2_nodes, "IMG", {
				src: true,
				alt: true,
				"aria-hidden": true,
				class: true
			});

			t0 = claim_text(span2_nodes, "\n                  Savings from ");
			span0 = claim_element(span2_nodes, "SPAN", { class: true });
			var span0_nodes = children(span0);
			t1 = claim_text(span0_nodes, "a ");
			t2 = claim_text(span0_nodes, t2_value);
			t3 = claim_text(span0_nodes, "kW");
			span0_nodes.forEach(detach);
			span1 = claim_element(span2_nodes, "SPAN", { class: true });
			var span1_nodes = children(span1);
			t4 = claim_text(span1_nodes, "this");
			span1_nodes.forEach(detach);
			t5 = claim_text(span2_nodes, " system");
			span2_nodes.forEach(detach);
			t6 = claim_space(div0_nodes);
			ul0 = claim_element(div0_nodes, "UL", { class: true });
			var ul0_nodes = children(ul0);
			li0 = claim_element(ul0_nodes, "LI", { class: true });
			var li0_nodes = children(li0);
			span3 = claim_element(li0_nodes, "SPAN", { class: true });
			var span3_nodes = children(span3);
			t7 = claim_text(span3_nodes, "Est. yearly production\n                      ");
			claim_component(tooltip0.$$.fragment, span3_nodes);
			span3_nodes.forEach(detach);
			t8 = claim_space(li0_nodes);
			span4 = claim_element(li0_nodes, "SPAN", { class: true });
			var span4_nodes = children(span4);
			t9 = claim_text(span4_nodes, t9_value);
			t10 = claim_text(span4_nodes, " kWh");
			span4_nodes.forEach(detach);
			li0_nodes.forEach(detach);
			t11 = claim_space(ul0_nodes);
			li1 = claim_element(ul0_nodes, "LI", { class: true });
			var li1_nodes = children(li1);
			span5 = claim_element(li1_nodes, "SPAN", { class: true });
			var span5_nodes = children(span5);
			t12 = claim_text(span5_nodes, "Est. monthly savings");
			span5_nodes.forEach(detach);
			t13 = claim_space(li1_nodes);
			span6 = claim_element(li1_nodes, "SPAN", { class: true });
			var span6_nodes = children(span6);
			t14 = claim_text(span6_nodes, "$");
			t15 = claim_text(span6_nodes, t15_value);
			span6_nodes.forEach(detach);
			li1_nodes.forEach(detach);
			t16 = claim_space(ul0_nodes);
			li2 = claim_element(ul0_nodes, "LI", { class: true });
			var li2_nodes = children(li2);
			span7 = claim_element(li2_nodes, "SPAN", { class: true });
			var span7_nodes = children(span7);
			t17 = claim_text(span7_nodes, "Full payback in");
			span7_nodes.forEach(detach);
			t18 = claim_space(li2_nodes);
			span8 = claim_element(li2_nodes, "SPAN", { class: true });
			var span8_nodes = children(span8);
			t19 = claim_text(span8_nodes, t19_value);
			t20 = claim_text(span8_nodes, " years\n                      ");
			claim_component(tooltip1.$$.fragment, span8_nodes);
			span8_nodes.forEach(detach);
			li2_nodes.forEach(detach);
			ul0_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t21 = claim_space(nodes);
			div1 = claim_element(nodes, "DIV", {});
			var div1_nodes = children(div1);
			span9 = claim_element(div1_nodes, "SPAN", { class: true });
			var span9_nodes = children(span9);

			img1 = claim_element(span9_nodes, "IMG", {
				src: true,
				alt: true,
				"aria-hidden": true,
				class: true
			});

			t22 = claim_text(span9_nodes, "\n                  Environmental Impacts");
			span9_nodes.forEach(detach);
			t23 = claim_space(div1_nodes);
			ul1 = claim_element(div1_nodes, "UL", { class: true });
			var ul1_nodes = children(ul1);
			li3 = claim_element(ul1_nodes, "LI", { class: true });
			var li3_nodes = children(li3);
			span10 = claim_element(li3_nodes, "SPAN", { class: true });
			var span10_nodes = children(span10);
			t24 = claim_text(span10_nodes, "Reduces CO2 emissions by");
			span10_nodes.forEach(detach);
			t25 = claim_space(li3_nodes);
			span11 = claim_element(li3_nodes, "SPAN", { class: true });
			var span11_nodes = children(span11);
			t26 = claim_text(span11_nodes, t26_value);
			t27 = claim_text(span11_nodes, " tons a year");
			span11_nodes.forEach(detach);
			li3_nodes.forEach(detach);
			t28 = claim_space(ul1_nodes);
			li4 = claim_element(ul1_nodes, "LI", { class: true });
			var li4_nodes = children(li4);
			span12 = claim_element(li4_nodes, "SPAN", { class: true });
			var span12_nodes = children(span12);
			t29 = claim_text(span12_nodes, "Equivalent to planting");
			span12_nodes.forEach(detach);
			t30 = claim_space(li4_nodes);
			span13 = claim_element(li4_nodes, "SPAN", { class: true });
			var span13_nodes = children(span13);
			t31 = claim_text(span13_nodes, t31_value);
			t32 = claim_text(span13_nodes, " trees a year");
			span13_nodes.forEach(detach);
			li4_nodes.forEach(detach);
			t33 = claim_space(ul1_nodes);
			li5 = claim_element(ul1_nodes, "LI", { class: true });
			var li5_nodes = children(li5);
			span14 = claim_element(li5_nodes, "SPAN", { class: true });
			var span14_nodes = children(span14);
			t34 = claim_text(span14_nodes, "Equivalent to driving");
			span14_nodes.forEach(detach);
			t35 = claim_space(li5_nodes);
			span15 = claim_element(li5_nodes, "SPAN", { class: true });
			var span15_nodes = children(span15);
			t36 = claim_text(span15_nodes, t36_value);
			t37 = claim_text(span15_nodes, " mi less a year");
			span15_nodes.forEach(detach);
			li5_nodes.forEach(detach);
			ul1_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (!src_url_equal(img0.src, img0_src_value = "/site-images/savings.svg")) attr(img0, "src", img0_src_value);
			attr(img0, "alt", "");
			attr(img0, "aria-hidden", "true");
			attr(img0, "class", "svelte-dsa0xa");
			attr(span0, "class", "desktop svelte-dsa0xa");
			attr(span1, "class", "mobile svelte-dsa0xa");
			attr(span2, "class", "benefits__title benefits__title--first svelte-dsa0xa");
			attr(span3, "class", "benefits__item-name svelte-dsa0xa");
			attr(span4, "class", "benefits__item-value svelte-dsa0xa");
			attr(li0, "class", "svelte-dsa0xa");
			attr(span5, "class", "benefits__item-name svelte-dsa0xa");
			attr(span6, "class", "benefits__item-value svelte-dsa0xa");
			attr(li1, "class", "svelte-dsa0xa");
			attr(span7, "class", "benefits__item-name svelte-dsa0xa");
			attr(span8, "class", "benefits__item-value svelte-dsa0xa");
			attr(li2, "class", "svelte-dsa0xa");
			attr(ul0, "class", "benefits__items svelte-dsa0xa");
			if (!src_url_equal(img1.src, img1_src_value = "/site-images/world.svg")) attr(img1, "src", img1_src_value);
			attr(img1, "alt", "");
			attr(img1, "aria-hidden", "true");
			attr(img1, "class", "svelte-dsa0xa");
			attr(span9, "class", "benefits__title svelte-dsa0xa");
			attr(span10, "class", "benefits__item-name svelte-dsa0xa");
			attr(span11, "class", "benefits__item-value svelte-dsa0xa");
			attr(li3, "class", "svelte-dsa0xa");
			attr(span12, "class", "benefits__item-name svelte-dsa0xa");
			attr(span13, "class", "benefits__item-value svelte-dsa0xa");
			attr(li4, "class", "svelte-dsa0xa");
			attr(span14, "class", "benefits__item-name svelte-dsa0xa");
			attr(span15, "class", "benefits__item-value svelte-dsa0xa");
			attr(li5, "class", "svelte-dsa0xa");
			attr(ul1, "class", "benefits__items benefits__items--wrap svelte-dsa0xa");
		},
		m(target, anchor) {
			insert_hydration(target, div0, anchor);
			append_hydration(div0, span2);
			append_hydration(span2, img0);
			append_hydration(span2, t0);
			append_hydration(span2, span0);
			append_hydration(span0, t1);
			append_hydration(span0, t2);
			append_hydration(span0, t3);
			append_hydration(span2, span1);
			append_hydration(span1, t4);
			append_hydration(span2, t5);
			append_hydration(div0, t6);
			append_hydration(div0, ul0);
			append_hydration(ul0, li0);
			append_hydration(li0, span3);
			append_hydration(span3, t7);
			mount_component(tooltip0, span3, null);
			append_hydration(li0, t8);
			append_hydration(li0, span4);
			append_hydration(span4, t9);
			append_hydration(span4, t10);
			append_hydration(ul0, t11);
			append_hydration(ul0, li1);
			append_hydration(li1, span5);
			append_hydration(span5, t12);
			append_hydration(li1, t13);
			append_hydration(li1, span6);
			append_hydration(span6, t14);
			append_hydration(span6, t15);
			append_hydration(ul0, t16);
			append_hydration(ul0, li2);
			append_hydration(li2, span7);
			append_hydration(span7, t17);
			append_hydration(li2, t18);
			append_hydration(li2, span8);
			append_hydration(span8, t19);
			append_hydration(span8, t20);
			mount_component(tooltip1, span8, null);
			insert_hydration(target, t21, anchor);
			insert_hydration(target, div1, anchor);
			append_hydration(div1, span9);
			append_hydration(span9, img1);
			append_hydration(span9, t22);
			append_hydration(div1, t23);
			append_hydration(div1, ul1);
			append_hydration(ul1, li3);
			append_hydration(li3, span10);
			append_hydration(span10, t24);
			append_hydration(li3, t25);
			append_hydration(li3, span11);
			append_hydration(span11, t26);
			append_hydration(span11, t27);
			append_hydration(ul1, t28);
			append_hydration(ul1, li4);
			append_hydration(li4, span12);
			append_hydration(span12, t29);
			append_hydration(li4, t30);
			append_hydration(li4, span13);
			append_hydration(span13, t31);
			append_hydration(span13, t32);
			append_hydration(ul1, t33);
			append_hydration(ul1, li5);
			append_hydration(li5, span14);
			append_hydration(span14, t34);
			append_hydration(li5, t35);
			append_hydration(li5, span15);
			append_hydration(span15, t36);
			append_hydration(span15, t37);
			current = true;
		},
		p(ctx, dirty) {
			const tooltip0_changes = {};
			if (dirty[0] & /*userUtilityBill*/ 512) tooltip0_changes.text = "Equivalent to about $" + roundFormat(/*getConsumptionPercentage*/ ctx[13](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9], true)) + "% of yearly electricity needs based on a monthly bill of $" + roundFormat(/*userUtilityBill*/ ctx[9]) + ".";
			tooltip0.$set(tooltip0_changes);
			if ((!current || dirty[0] & /*userUtilityBill*/ 512) && t9_value !== (t9_value = roundFormat(/*getkWhProducedYearly*/ ctx[14](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9])) + "")) set_data(t9, t9_value);
			if ((!current || dirty[0] & /*userUtilityBill*/ 512) && t15_value !== (t15_value = roundFormat(/*getMonthlySavings*/ ctx[15](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9])) + "")) set_data(t15, t15_value);
			if ((!current || dirty[0] & /*userUtilityBill*/ 512) && t19_value !== (t19_value = /*getPaybackPeriod*/ ctx[12](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9]) + "")) set_data(t19, t19_value);
			if ((!current || dirty[0] & /*userUtilityBill*/ 512) && t26_value !== (t26_value = /*getCO2EmissionsInTons*/ ctx[17](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9]) + "")) set_data(t26, t26_value);
			if ((!current || dirty[0] & /*userUtilityBill*/ 512) && t31_value !== (t31_value = /*getTreesPlantedPerYear*/ ctx[19](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9]) + "")) set_data(t31, t31_value);
			if ((!current || dirty[0] & /*userUtilityBill*/ 512) && t36_value !== (t36_value = /*getMilesPerYear*/ ctx[18](/*size*/ ctx[31], /*userUtilityBill*/ ctx[9]) + "")) set_data(t36, t36_value);
		},
		i(local) {
			if (current) return;
			transition_in(tooltip0.$$.fragment, local);
			transition_in(tooltip1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tooltip0.$$.fragment, local);
			transition_out(tooltip1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div0);
			destroy_component(tooltip0);
			destroy_component(tooltip1);
			if (detaching) detach(t21);
			if (detaching) detach(div1);
		}
	};
}

// (186:6) {#each commonSizes as size, index}
function create_each_block(ctx) {
	let section1;
	let div0;
	let button0;
	let img0;
	let img0_src_value;
	let t0;
	let button1;
	let img1;
	let img1_src_value;
	let t1;
	let div1;
	let span0;
	let t2;
	let t3;
	let span1;
	let t4_value = /*size*/ ctx[31] + "";
	let t4;
	let t5;
	let t6;
	let div3;
	let div2;
	let t7;
	let span2;
	let t8;
	let t9;
	let span3;
	let t10_value = roundFormat(/*size*/ ctx[31] * 1000 / 250 * 3.25 * 5.5) + "";
	let t10;
	let t11;
	let tooltip0;
	let t12;
	let div4;
	let span5;
	let t13;
	let tooltip1;
	let t14;
	let span4;
	let t15;
	let t16;
	let span7;
	let t17;
	let t18_value = /*getElectricityValue*/ ctx[16](/*size*/ ctx[31]) + "";
	let t18;
	let t19;
	let span6;
	let t20;
	let t21;
	let div6;
	let div5;
	let t22;
	let tooltip2;
	let t23;
	let span8;
	let t24_value = /*getSystemPrice*/ ctx[11](/*size*/ ctx[31]) + "";
	let t24;
	let t25;
	let section0;
	let current_block_type_index;
	let if_block;
	let t26;
	let current;
	let mounted;
	let dispose;

	function click_handler() {
		return /*click_handler*/ ctx[24](/*index*/ ctx[33]);
	}

	function click_handler_1() {
		return /*click_handler_1*/ ctx[25](/*index*/ ctx[33]);
	}

	tooltip0 = new Tooltip({
			props: {
				text: "About " + /*getSystemRoofPercent*/ ctx[20](/*size*/ ctx[31]) + " of roofs fit this system size."
			}
		});

	tooltip1 = new Tooltip({
			props: {
				text: "Annual production based on the average utility bill, available sunlight, and system size."
			}
		});

	tooltip2 = new Tooltip({
			props: {
				text: "Varies based on tax credits & system."
			}
		});

	const if_block_creators = [create_if_block_1, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*userUtilityBill*/ ctx[9] > 0) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, [-1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	function mouseover_handler() {
		return /*mouseover_handler*/ ctx[26](/*size*/ ctx[31], /*index*/ ctx[33]);
	}

	return {
		c() {
			section1 = element("section");
			div0 = element("div");
			button0 = element("button");
			img0 = element("img");
			t0 = space();
			button1 = element("button");
			img1 = element("img");
			t1 = space();
			div1 = element("div");
			span0 = element("span");
			t2 = text("System Size");
			t3 = space();
			span1 = element("span");
			t4 = text(t4_value);
			t5 = text("kW");
			t6 = space();
			div3 = element("div");
			div2 = element("div");
			t7 = text("Roof Size\n              ");
			span2 = element("span");
			t8 = text("Min. space required");
			t9 = space();
			span3 = element("span");
			t10 = text(t10_value);
			t11 = text(" ft²\n              ");
			create_component(tooltip0.$$.fragment);
			t12 = space();
			div4 = element("div");
			span5 = element("span");
			t13 = text("Electricity Value ");
			create_component(tooltip1.$$.fragment);
			t14 = space();
			span4 = element("span");
			t15 = text("Annual Production");
			t16 = space();
			span7 = element("span");
			t17 = text("$");
			t18 = text(t18_value);
			t19 = space();
			span6 = element("span");
			t20 = text("a year");
			t21 = space();
			div6 = element("div");
			div5 = element("div");
			t22 = text("Est. Price ");
			create_component(tooltip2.$$.fragment);
			t23 = space();
			span8 = element("span");
			t24 = text(t24_value);
			t25 = space();
			section0 = element("section");
			if_block.c();
			t26 = space();
			this.h();
		},
		l(nodes) {
			section1 = claim_element(nodes, "SECTION", { class: true });
			var section1_nodes = children(section1);
			div0 = claim_element(section1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			button0 = claim_element(div0_nodes, "BUTTON", { class: true, "aria-hidden": true });
			var button0_nodes = children(button0);

			img0 = claim_element(button0_nodes, "IMG", {
				src: true,
				alt: true,
				"aria-hidden": true
			});

			button0_nodes.forEach(detach);
			t0 = claim_space(div0_nodes);
			button1 = claim_element(div0_nodes, "BUTTON", { class: true, "aria-hidden": true });
			var button1_nodes = children(button1);

			img1 = claim_element(button1_nodes, "IMG", {
				src: true,
				alt: true,
				"aria-hidden": true
			});

			button1_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t1 = claim_space(section1_nodes);
			div1 = claim_element(section1_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			span0 = claim_element(div1_nodes, "SPAN", { class: true });
			var span0_nodes = children(span0);
			t2 = claim_text(span0_nodes, "System Size");
			span0_nodes.forEach(detach);
			t3 = claim_space(div1_nodes);
			span1 = claim_element(div1_nodes, "SPAN", { class: true });
			var span1_nodes = children(span1);
			t4 = claim_text(span1_nodes, t4_value);
			t5 = claim_text(span1_nodes, "kW");
			span1_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			t6 = claim_space(section1_nodes);
			div3 = claim_element(section1_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			t7 = claim_text(div2_nodes, "Roof Size\n              ");
			span2 = claim_element(div2_nodes, "SPAN", { class: true });
			var span2_nodes = children(span2);
			t8 = claim_text(span2_nodes, "Min. space required");
			span2_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			t9 = claim_space(div3_nodes);
			span3 = claim_element(div3_nodes, "SPAN", { class: true });
			var span3_nodes = children(span3);
			t10 = claim_text(span3_nodes, t10_value);
			t11 = claim_text(span3_nodes, " ft²\n              ");
			claim_component(tooltip0.$$.fragment, span3_nodes);
			span3_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			t12 = claim_space(section1_nodes);
			div4 = claim_element(section1_nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			span5 = claim_element(div4_nodes, "SPAN", { class: true });
			var span5_nodes = children(span5);
			t13 = claim_text(span5_nodes, "Electricity Value ");
			claim_component(tooltip1.$$.fragment, span5_nodes);
			t14 = claim_space(span5_nodes);
			span4 = claim_element(span5_nodes, "SPAN", { class: true });
			var span4_nodes = children(span4);
			t15 = claim_text(span4_nodes, "Annual Production");
			span4_nodes.forEach(detach);
			span5_nodes.forEach(detach);
			t16 = claim_space(div4_nodes);
			span7 = claim_element(div4_nodes, "SPAN", { class: true });
			var span7_nodes = children(span7);
			t17 = claim_text(span7_nodes, "$");
			t18 = claim_text(span7_nodes, t18_value);
			t19 = claim_space(span7_nodes);
			span6 = claim_element(span7_nodes, "SPAN", { class: true });
			var span6_nodes = children(span6);
			t20 = claim_text(span6_nodes, "a year");
			span6_nodes.forEach(detach);
			span7_nodes.forEach(detach);
			div4_nodes.forEach(detach);
			t21 = claim_space(section1_nodes);
			div6 = claim_element(section1_nodes, "DIV", { class: true });
			var div6_nodes = children(div6);
			div5 = claim_element(div6_nodes, "DIV", { class: true });
			var div5_nodes = children(div5);
			t22 = claim_text(div5_nodes, "Est. Price ");
			claim_component(tooltip2.$$.fragment, div5_nodes);
			div5_nodes.forEach(detach);
			t23 = claim_space(div6_nodes);
			span8 = claim_element(div6_nodes, "SPAN", { class: true });
			var span8_nodes = children(span8);
			t24 = claim_text(span8_nodes, t24_value);
			span8_nodes.forEach(detach);
			div6_nodes.forEach(detach);
			t25 = claim_space(section1_nodes);
			section0 = claim_element(section1_nodes, "SECTION", { class: true });
			var section0_nodes = children(section0);
			if_block.l(section0_nodes);
			section0_nodes.forEach(detach);
			t26 = claim_space(section1_nodes);
			section1_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (!src_url_equal(img0.src, img0_src_value = "/site-images/chevron-right.svg")) attr(img0, "src", img0_src_value);
			attr(img0, "alt", "");
			attr(img0, "aria-hidden", "true");
			attr(button0, "class", "controls__button controls__button--left svelte-dsa0xa");
			attr(button0, "aria-hidden", "true");
			toggle_class(button0, "controls__button--hidden", /*index*/ ctx[33] === 0);
			if (!src_url_equal(img1.src, img1_src_value = "/site-images/chevron-right.svg")) attr(img1, "src", img1_src_value);
			attr(img1, "alt", "");
			attr(img1, "aria-hidden", "true");
			attr(button1, "class", "controls__button controls__button--right svelte-dsa0xa");
			attr(button1, "aria-hidden", "true");
			toggle_class(button1, "controls__button--hidden", /*index*/ ctx[33] === 4);
			attr(div0, "class", "controls svelte-dsa0xa");
			attr(span0, "class", "field__label svelte-dsa0xa");
			attr(span1, "class", "field__value svelte-dsa0xa");
			attr(div1, "class", "field field--heading svelte-dsa0xa");
			attr(span2, "class", "svelte-dsa0xa");
			attr(div2, "class", "field__label svelte-dsa0xa");
			attr(span3, "class", "field__value svelte-dsa0xa");
			attr(div3, "class", "field svelte-dsa0xa");
			attr(span4, "class", "svelte-dsa0xa");
			attr(span5, "class", "field__label svelte-dsa0xa");
			attr(span6, "class", "field__value-suffix svelte-dsa0xa");
			attr(span7, "class", "field__value svelte-dsa0xa");
			attr(div4, "class", "field svelte-dsa0xa");
			attr(div5, "class", "field__label svelte-dsa0xa");
			attr(span8, "class", "field__value svelte-dsa0xa");
			attr(div6, "class", "field svelte-dsa0xa");
			attr(section0, "class", "benefits svelte-dsa0xa");
			attr(section1, "class", "system-detail svelte-dsa0xa");
			toggle_class(section1, "system-detail--active", /*currentSlide*/ ctx[8] === /*index*/ ctx[33]);
		},
		m(target, anchor) {
			insert_hydration(target, section1, anchor);
			append_hydration(section1, div0);
			append_hydration(div0, button0);
			append_hydration(button0, img0);
			append_hydration(div0, t0);
			append_hydration(div0, button1);
			append_hydration(button1, img1);
			append_hydration(section1, t1);
			append_hydration(section1, div1);
			append_hydration(div1, span0);
			append_hydration(span0, t2);
			append_hydration(div1, t3);
			append_hydration(div1, span1);
			append_hydration(span1, t4);
			append_hydration(span1, t5);
			append_hydration(section1, t6);
			append_hydration(section1, div3);
			append_hydration(div3, div2);
			append_hydration(div2, t7);
			append_hydration(div2, span2);
			append_hydration(span2, t8);
			append_hydration(div3, t9);
			append_hydration(div3, span3);
			append_hydration(span3, t10);
			append_hydration(span3, t11);
			mount_component(tooltip0, span3, null);
			append_hydration(section1, t12);
			append_hydration(section1, div4);
			append_hydration(div4, span5);
			append_hydration(span5, t13);
			mount_component(tooltip1, span5, null);
			append_hydration(span5, t14);
			append_hydration(span5, span4);
			append_hydration(span4, t15);
			append_hydration(div4, t16);
			append_hydration(div4, span7);
			append_hydration(span7, t17);
			append_hydration(span7, t18);
			append_hydration(span7, t19);
			append_hydration(span7, span6);
			append_hydration(span6, t20);
			append_hydration(section1, t21);
			append_hydration(section1, div6);
			append_hydration(div6, div5);
			append_hydration(div5, t22);
			mount_component(tooltip2, div5, null);
			append_hydration(div6, t23);
			append_hydration(div6, span8);
			append_hydration(span8, t24);
			append_hydration(section1, t25);
			append_hydration(section1, section0);
			if_blocks[current_block_type_index].m(section0, null);
			append_hydration(section1, t26);
			current = true;

			if (!mounted) {
				dispose = [
					listen(button0, "click", click_handler),
					listen(button1, "click", click_handler_1),
					listen(section1, "mouseover", mouseover_handler)
				];

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(section0, null);
			}

			if (dirty[0] & /*currentSlide*/ 256) {
				toggle_class(section1, "system-detail--active", /*currentSlide*/ ctx[8] === /*index*/ ctx[33]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(tooltip0.$$.fragment, local);
			transition_in(tooltip1.$$.fragment, local);
			transition_in(tooltip2.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(tooltip0.$$.fragment, local);
			transition_out(tooltip1.$$.fragment, local);
			transition_out(tooltip2.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(section1);
			destroy_component(tooltip0);
			destroy_component(tooltip1);
			destroy_component(tooltip2);
			if_blocks[current_block_type_index].d();
			mounted = false;
			run_all(dispose);
		}
	};
}

// (316:6) {#if componentEmbedId || debugEmbedId}
function create_if_block(ctx) {
	let embedmodal;
	let updating_isModalOpen;
	let current;

	function embedmodal_isModalOpen_binding(value) {
		/*embedmodal_isModalOpen_binding*/ ctx[28](value);
	}

	let embedmodal_props = {
		componentEmbedId: /*componentEmbedId*/ ctx[0] || debugEmbedId,
		embedOrigin: /*embedOrigin*/ ctx[5],
		buttonClasses: "margin-top"
	};

	if (/*isModalOpen*/ ctx[6] !== void 0) {
		embedmodal_props.isModalOpen = /*isModalOpen*/ ctx[6];
	}

	embedmodal = new EmbedModal({ props: embedmodal_props });
	binding_callbacks.push(() => bind(embedmodal, 'isModalOpen', embedmodal_isModalOpen_binding));

	return {
		c() {
			create_component(embedmodal.$$.fragment);
		},
		l(nodes) {
			claim_component(embedmodal.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(embedmodal, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const embedmodal_changes = {};
			if (dirty[0] & /*componentEmbedId*/ 1) embedmodal_changes.componentEmbedId = /*componentEmbedId*/ ctx[0] || debugEmbedId;
			if (dirty[0] & /*embedOrigin*/ 32) embedmodal_changes.embedOrigin = /*embedOrigin*/ ctx[5];

			if (!updating_isModalOpen && dirty[0] & /*isModalOpen*/ 64) {
				updating_isModalOpen = true;
				embedmodal_changes.isModalOpen = /*isModalOpen*/ ctx[6];
				add_flush_callback(() => updating_isModalOpen = false);
			}

			embedmodal.$set(embedmodal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(embedmodal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(embedmodal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(embedmodal, detaching);
		}
	};
}

function create_fragment(ctx) {
	let t0;
	let section;
	let div0;
	let h2;
	let t1;
	let t2;
	let t3;
	let p0;
	let t4_value = /*data*/ ctx[3][`solar${capitalize(/*locationType*/ ctx[2])}AveragePanelCostsP1`].map(func).join(' ') + "";
	let t4;
	let t5;
	let p1;
	let t6_value = /*data*/ ctx[3][`solar${capitalize(/*locationType*/ ctx[2])}AveragePanelCostsP2`].map(func_1).join(' ') + "";
	let t6;
	let t7;
	let div8;
	let div5;
	let div1;
	let t8;
	let t9;
	let div2;
	let t10;
	let span0;
	let t11;
	let t12;
	let div3;
	let t13;
	let tooltip0;
	let t14;
	let span1;
	let t15;
	let t16;
	let div4;
	let t17;
	let tooltip1;
	let t18;
	let div6;
	let t19;
	let div7;
	let t20;
	let div9;
	let label;
	let t21;
	let t22;
	let input;
	let current;
	let mounted;
	let dispose;
	let if_block0 = /*embedDetector*/ ctx[4] && create_if_block_2(ctx);

	tooltip0 = new Tooltip({
			props: {
				text: "Annual production based on the average utility bill, available sunlight, and system size."
			}
		});

	tooltip1 = new Tooltip({
			props: {
				text: "Varies based on tax credits & system."
			}
		});

	let each_value = /*commonSizes*/ ctx[10];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	let if_block1 = (/*componentEmbedId*/ ctx[0] || debugEmbedId) && create_if_block(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			section = element("section");
			div0 = element("div");
			h2 = element("h2");
			t1 = text("Average solar panel costs by system size in ");
			t2 = text(/*name*/ ctx[1]);
			t3 = space();
			p0 = element("p");
			t4 = text(t4_value);
			t5 = space();
			p1 = element("p");
			t6 = text(t6_value);
			t7 = space();
			div8 = element("div");
			div5 = element("div");
			div1 = element("div");
			t8 = text("System Size");
			t9 = space();
			div2 = element("div");
			t10 = text("Roof Size\n        ");
			span0 = element("span");
			t11 = text("Min. space required");
			t12 = space();
			div3 = element("div");
			t13 = text("Electricity Value ");
			create_component(tooltip0.$$.fragment);
			t14 = space();
			span1 = element("span");
			t15 = text("Annual Production");
			t16 = space();
			div4 = element("div");
			t17 = text("Est. Price ");
			create_component(tooltip1.$$.fragment);
			t18 = space();
			div6 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t19 = space();
			div7 = element("div");
			if (if_block1) if_block1.c();
			t20 = space();
			div9 = element("div");
			label = element("label");
			t21 = text("Current utility bill:");
			t22 = space();
			input = element("input");
			this.h();
		},
		l(nodes) {
			if (if_block0) if_block0.l(nodes);
			t0 = claim_space(nodes);
			section = claim_element(nodes, "SECTION", { id: true, class: true });
			var section_nodes = children(section);
			div0 = claim_element(section_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			h2 = claim_element(div0_nodes, "H2", { class: true });
			var h2_nodes = children(h2);
			t1 = claim_text(h2_nodes, "Average solar panel costs by system size in ");
			t2 = claim_text(h2_nodes, /*name*/ ctx[1]);
			h2_nodes.forEach(detach);
			t3 = claim_space(div0_nodes);
			p0 = claim_element(div0_nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t4 = claim_text(p0_nodes, t4_value);
			p0_nodes.forEach(detach);
			t5 = claim_space(div0_nodes);
			p1 = claim_element(div0_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t6 = claim_text(p1_nodes, t6_value);
			p1_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t7 = claim_space(section_nodes);
			div8 = claim_element(section_nodes, "DIV", { class: true });
			var div8_nodes = children(div8);
			div5 = claim_element(div8_nodes, "DIV", { "aria-hidden": true, class: true });
			var div5_nodes = children(div5);
			div1 = claim_element(div5_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			t8 = claim_text(div1_nodes, "System Size");
			div1_nodes.forEach(detach);
			t9 = claim_space(div5_nodes);
			div2 = claim_element(div5_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			t10 = claim_text(div2_nodes, "Roof Size\n        ");
			span0 = claim_element(div2_nodes, "SPAN", { class: true });
			var span0_nodes = children(span0);
			t11 = claim_text(span0_nodes, "Min. space required");
			span0_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			t12 = claim_space(div5_nodes);
			div3 = claim_element(div5_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			t13 = claim_text(div3_nodes, "Electricity Value ");
			claim_component(tooltip0.$$.fragment, div3_nodes);
			t14 = claim_space(div3_nodes);
			span1 = claim_element(div3_nodes, "SPAN", { class: true });
			var span1_nodes = children(span1);
			t15 = claim_text(span1_nodes, "Annual Production");
			span1_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			t16 = claim_space(div5_nodes);
			div4 = claim_element(div5_nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			t17 = claim_text(div4_nodes, "Est. Price ");
			claim_component(tooltip1.$$.fragment, div4_nodes);
			div4_nodes.forEach(detach);
			div5_nodes.forEach(detach);
			t18 = claim_space(div8_nodes);
			div6 = claim_element(div8_nodes, "DIV", { class: true });
			var div6_nodes = children(div6);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(div6_nodes);
			}

			div6_nodes.forEach(detach);
			t19 = claim_space(div8_nodes);
			div7 = claim_element(div8_nodes, "DIV", { id: true, class: true });
			var div7_nodes = children(div7);
			if (if_block1) if_block1.l(div7_nodes);
			div7_nodes.forEach(detach);
			div8_nodes.forEach(detach);
			t20 = claim_space(section_nodes);
			div9 = claim_element(section_nodes, "DIV", { class: true });
			var div9_nodes = children(div9);
			label = claim_element(div9_nodes, "LABEL", { for: true, class: true });
			var label_nodes = children(label);
			t21 = claim_text(label_nodes, "Current utility bill:");
			label_nodes.forEach(detach);
			t22 = claim_space(div9_nodes);

			input = claim_element(div9_nodes, "INPUT", {
				id: true,
				min: true,
				max: true,
				type: true,
				name: true,
				class: true
			});

			div9_nodes.forEach(detach);
			section_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h2, "class", "system-compare__heading mb-3 svelte-dsa0xa");
			attr(p0, "class", "text-center");
			attr(p1, "class", "text-center");
			attr(div0, "class", "system-compare__content container svelte-dsa0xa");
			attr(div1, "class", "table-header__col svelte-dsa0xa");
			attr(span0, "class", "svelte-dsa0xa");
			attr(div2, "class", "table-header__col svelte-dsa0xa");
			attr(span1, "class", "svelte-dsa0xa");
			attr(div3, "class", "table-header__col svelte-dsa0xa");
			attr(div4, "class", "table-header__col svelte-dsa0xa");
			attr(div5, "aria-hidden", "true");
			attr(div5, "class", "table-header svelte-dsa0xa");
			attr(div6, "class", "table-track svelte-dsa0xa");
			attr(div7, "id", "embed-button");
			attr(div7, "class", "svelte-dsa0xa");
			attr(div8, "class", "table-wrapper svelte-dsa0xa");
			attr(label, "for", "utility-bill-input");
			attr(label, "class", "svelte-dsa0xa");
			attr(input, "id", "utility-bill-input");
			attr(input, "min", "1");
			attr(input, "max", "9999");
			attr(input, "type", "number");
			attr(input, "name", "utility-bill");
			attr(input, "class", "svelte-dsa0xa");
			attr(div9, "class", "system-compare__form svelte-dsa0xa");
			attr(section, "id", "system-compare");
			attr(section, "class", "system-compare section-gap svelte-dsa0xa");
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert_hydration(target, t0, anchor);
			insert_hydration(target, section, anchor);
			append_hydration(section, div0);
			append_hydration(div0, h2);
			append_hydration(h2, t1);
			append_hydration(h2, t2);
			append_hydration(div0, t3);
			append_hydration(div0, p0);
			append_hydration(p0, t4);
			append_hydration(div0, t5);
			append_hydration(div0, p1);
			append_hydration(p1, t6);
			append_hydration(section, t7);
			append_hydration(section, div8);
			append_hydration(div8, div5);
			append_hydration(div5, div1);
			append_hydration(div1, t8);
			append_hydration(div5, t9);
			append_hydration(div5, div2);
			append_hydration(div2, t10);
			append_hydration(div2, span0);
			append_hydration(span0, t11);
			append_hydration(div5, t12);
			append_hydration(div5, div3);
			append_hydration(div3, t13);
			mount_component(tooltip0, div3, null);
			append_hydration(div3, t14);
			append_hydration(div3, span1);
			append_hydration(span1, t15);
			append_hydration(div5, t16);
			append_hydration(div5, div4);
			append_hydration(div4, t17);
			mount_component(tooltip1, div4, null);
			append_hydration(div8, t18);
			append_hydration(div8, div6);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div6, null);
			}

			/*div6_binding*/ ctx[27](div6);
			append_hydration(div8, t19);
			append_hydration(div8, div7);
			if (if_block1) if_block1.m(div7, null);
			append_hydration(section, t20);
			append_hydration(section, div9);
			append_hydration(div9, label);
			append_hydration(label, t21);
			append_hydration(div9, t22);
			append_hydration(div9, input);
			set_input_value(input, /*userUtilityBill*/ ctx[9]);
			current = true;

			if (!mounted) {
				dispose = listen(input, "input", /*input_input_handler*/ ctx[29]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (/*embedDetector*/ ctx[4]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_2(ctx);
					if_block0.c();
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (!current || dirty[0] & /*name*/ 2) set_data(t2, /*name*/ ctx[1]);
			if ((!current || dirty[0] & /*data, locationType*/ 12) && t4_value !== (t4_value = /*data*/ ctx[3][`solar${capitalize(/*locationType*/ ctx[2])}AveragePanelCostsP1`].map(func).join(' ') + "")) set_data(t4, t4_value);
			if ((!current || dirty[0] & /*data, locationType*/ 12) && t6_value !== (t6_value = /*data*/ ctx[3][`solar${capitalize(/*locationType*/ ctx[2])}AveragePanelCostsP2`].map(func_1).join(' ') + "")) set_data(t6, t6_value);

			if (dirty[0] & /*currentSlide, selectRow, commonSizes, getMilesPerYear, userUtilityBill, getTreesPlantedPerYear, getCO2EmissionsInTons, getPaybackPeriod, getMonthlySavings, getkWhProducedYearly, getConsumptionPercentage, getSystemPrice, getElectricityValue, getSystemRoofPercent, transitionSlide*/ 8388352) {
				each_value = /*commonSizes*/ ctx[10];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(div6, null);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (/*componentEmbedId*/ ctx[0] || debugEmbedId) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*componentEmbedId*/ 1) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div7, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (dirty[0] & /*userUtilityBill*/ 512 && to_number(input.value) !== /*userUtilityBill*/ ctx[9]) {
				set_input_value(input, /*userUtilityBill*/ ctx[9]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(tooltip0.$$.fragment, local);
			transition_in(tooltip1.$$.fragment, local);

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(tooltip0.$$.fragment, local);
			transition_out(tooltip1.$$.fragment, local);
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			if (detaching) detach(section);
			destroy_component(tooltip0);
			destroy_component(tooltip1);
			destroy_each(each_blocks, detaching);
			/*div6_binding*/ ctx[27](null);
			if (if_block1) if_block1.d();
			mounted = false;
			dispose();
		}
	};
}

let debugEmbedId = '';

function capitalize(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

const func = v => v.value;
const func_1 = v => v.value;

function instance($$self, $$props, $$invalidate) {
	let { name = '' } = $$props;
	let { locationType } = $$props;
	let { stateInfo, data } = $$props;
	let { componentEmbedId } = $$props;
	let { embedDetector } = $$props;
	let { embedOrigin } = $$props;
	let isModalOpen = false;

	onMount(() => {
		if (!embedDetector) {
			console.warn('No embed detector provided');
			return;
		}

		const component = document.getElementById(embedDetector);

		if (!component) {
			console.warn('No component found with the provided embed detector ID:', embedDetector);
			return;
		}

		const embedDetectorDivParent = component.parentElement;

		if (!embedDetectorDivParent) {
			console.warn('No parent element found for the embed detector');
			return;
		}

		const embedId = embedDetectorDivParent.getAttribute('data-embed-id');

		if (!embedId) {
			console.warn('No embed ID found on the component');
			return;
		}

		$$invalidate(0, componentEmbedId = embedId);
	});

	let trackEl;
	let currentSlide = 0;
	let userUtilityBill = Math.round(stateInfo.electricity_bill_12_month);
	const commonSizes = stateInfo.systemSizes;

	const getSystemPrice = systemSize => {
		const price = roundFormat(stateInfo.avgPricePerWatt * systemSize * 1000 * 0.7);
		return '$' + price;
	};

	const getPaybackPeriod = (systemSize, utilityBill) => {
		const price = stateInfo.avgPricePerWatt * systemSize * 1000 * 0.7;
		const annualSavings = stateInfo.electricity_bill_12_month * 12;
		return roundFormat(price / annualSavings);
	};

	const getConsumptionPercentage = (systemSize, utilityBill, ignoreCap = false) => {
		return getMonthlySavings(systemSize, utilityBill, ignoreCap) / utilityBill * 100;
	};

	const getkWhProducedYearly = systemSize => {
		return stateInfo.solarPotential.yearlyKWH * systemSize;
	};

	const getMonthlySavings = (systemSize, utilityBill, ignoreCap = false) => {
		let savings = stateInfo.solarPotential.yearlyKWH * systemSize / 12 * stateInfo.rate_12_month;
		if (ignoreCap) return savings;
		if (savings >= utilityBill) savings = utilityBill;
		return savings;
	};

	const getElectricityValue = (systemSize, utilityBill) => {
		return roundFormat(getMonthlySavings(systemSize, utilityBill) * 12);
	};

	const getCO2Emissions = (systemSize, utilityBill) => {
		let multiplier = getConsumptionPercentage(systemSize, utilityBill) / 100;
		if (multiplier >= 1) multiplier = 1;
		return stateInfo.total_emission_12_month_per_capita * multiplier;
	};

	const getCO2EmissionsInTons = (systemSize, utilityBill) => {
		return roundToMax2Decimals(getCO2Emissions(systemSize, utilityBill) / 1000);
	};

	const getMilesPerYear = (systemSize, utilityBill) => {
		// https://www.epa.gov/greenvehicles/greenhouse-gas-emissions-typical-passenger-vehicle
		const co2EmissionsPerYearPerPassanger = 4600; // kilograms

		const milesAYear = 11386.14; // Divided kilograms (4600) by 404 grams that a car burns per mile
		return roundFormat(getCO2Emissions(systemSize, utilityBill) * milesAYear / co2EmissionsPerYearPerPassanger);
	};

	const getTreesPlantedPerYear = (systemSize, utilityBill) => {
		// https://www.usda.gov/media/blog/2015/03/17/power-one-tree-very-air-we-breathe
		const co2PerTreeAYear = 21.7724;

		return roundFormat(getCO2Emissions(systemSize, utilityBill) / co2PerTreeAYear);
	};

	const getSystemRoofPercent = systemSize => {
		const sizes = stateInfo.solarPotential.roofSizes;
		let sum = 0;
		let startingPoint = 0;

		for (let i = 0; i < sizes.length; i++) {
			if (systemSize <= sizes[i][0]) {
				startingPoint = i;
				break;
			}
		}

		for (let i = startingPoint; i < sizes.length; i++) {
			sum += sizes[i][1];
		}

		const percent = sum / stateInfo.solarPotential.roofCount * 100;
		return `${roundFormat(percent)}%`;
	};

	const transitionSlide = (dir, i) => {
		const j = dir === 'left' ? i - 1 : i + 1;

		if (window.innerWidth < 576) {
			$$invalidate(7, trackEl.style.transform = `translateX( calc( calc( calc(100vw - 2rem) + 1rem) * ${j} * -1 ) )`, trackEl);
		} else if (window.innerWidth >= 576 && window.innerWidth < 768) {
			$$invalidate(7, trackEl.style.transform = `translateX( calc( 35rem * ${j} * -1 ) )`, trackEl);
		} else if (window.innerWidth >= 768 && window.innerWidth < 992) {
			$$invalidate(7, trackEl.style.transform = `translateX( calc( 46.5rem * ${j} * -1 ) )`, trackEl);
		} else if (window.innerWidth >= 992 && window.innerWidth < 1200) {
			$$invalidate(7, trackEl.style.transform = `translateX( calc( 35rem * ${j} * -1 ) )`, trackEl);
		}

		$$invalidate(8, currentSlide = j);
	};

	const selectRow = (size, index) => {
		if (window.innerWidth >= 992) {
			$$invalidate(8, currentSlide = index);
		}
	};

	const click_handler = index => transitionSlide('left', index);
	const click_handler_1 = index => transitionSlide('right', index);
	const mouseover_handler = (size, index) => selectRow(size, index);

	function div6_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			trackEl = $$value;
			$$invalidate(7, trackEl);
		});
	}

	function embedmodal_isModalOpen_binding(value) {
		isModalOpen = value;
		$$invalidate(6, isModalOpen);
	}

	function input_input_handler() {
		userUtilityBill = to_number(this.value);
		$$invalidate(9, userUtilityBill);
	}

	$$self.$$set = $$props => {
		if ('name' in $$props) $$invalidate(1, name = $$props.name);
		if ('locationType' in $$props) $$invalidate(2, locationType = $$props.locationType);
		if ('stateInfo' in $$props) $$invalidate(23, stateInfo = $$props.stateInfo);
		if ('data' in $$props) $$invalidate(3, data = $$props.data);
		if ('componentEmbedId' in $$props) $$invalidate(0, componentEmbedId = $$props.componentEmbedId);
		if ('embedDetector' in $$props) $$invalidate(4, embedDetector = $$props.embedDetector);
		if ('embedOrigin' in $$props) $$invalidate(5, embedOrigin = $$props.embedOrigin);
	};

	return [
		componentEmbedId,
		name,
		locationType,
		data,
		embedDetector,
		embedOrigin,
		isModalOpen,
		trackEl,
		currentSlide,
		userUtilityBill,
		commonSizes,
		getSystemPrice,
		getPaybackPeriod,
		getConsumptionPercentage,
		getkWhProducedYearly,
		getMonthlySavings,
		getElectricityValue,
		getCO2EmissionsInTons,
		getMilesPerYear,
		getTreesPlantedPerYear,
		getSystemRoofPercent,
		transitionSlide,
		selectRow,
		stateInfo,
		click_handler,
		click_handler_1,
		mouseover_handler,
		div6_binding,
		embedmodal_isModalOpen_binding,
		input_input_handler
	];
}

class SystemCompare extends SvelteComponent {
	constructor(options) {
		super();

		init(
			this,
			options,
			instance,
			create_fragment,
			safe_not_equal,
			{
				name: 1,
				locationType: 2,
				stateInfo: 23,
				data: 3,
				componentEmbedId: 0,
				embedDetector: 4,
				embedOrigin: 5
			},
			null,
			[-1, -1]
		);
	}
}

export default SystemCompare;